import { Card, CardContent } from "@/components/ui/card";
import { Trophy, Flag } from "lucide-react";

export function UnitsOyesSummary({ round, totalUnits, par3Holes }) {
  return (
    <>
      {/* Units Summary */}
      <Card className="card-default mb-4">
        <CardContent className="p-3">
          <h3 className="text-sm font-bold text-[#0F172A] mb-2 flex items-center gap-2">
            <Trophy className="w-4 h-4 text-[#D4A373]" />
            Unidades
          </h3>
          <div className="flex flex-wrap gap-3">
            {round?.players?.map((player) => (
              <div key={player.player_id} className="flex items-center gap-1.5">
                <span className={`w-1.5 h-1.5 rounded-full ${player.is_base ? 'bg-[#1B4D3E]' : 'bg-[#D4A373]'}`}></span>
                <span className="text-xs text-[#0F172A]">{player.name?.split(' ')[0]}</span>
                <span className={`text-sm font-bold ${totalUnits[player.player_id] > 0 ? 'text-[#D4A373]' : 'text-gray-400'}`}>{totalUnits[player.player_id]}</span>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>

      {/* Oyes */}
      {round?.oyes_results && Object.keys(round.oyes_results).length > 0 && (
        <Card className="card-default mb-4 bg-amber-50/50">
          <CardContent className="p-3">
            <h3 className="text-sm font-bold text-[#0F172A] mb-2 flex items-center gap-2">
              <Flag className="w-4 h-4 text-amber-600" />
              Oyes (Par 3)
            </h3>
            <div className="space-y-1.5">
              {par3Holes.map(holeNum => {
                const oyesResult = round?.oyes_results?.[String(holeNum)];
                if (!oyesResult) return null;
                return (
                  <div key={holeNum} className="flex items-center justify-between text-xs">
                    <span className="font-medium text-[#0F172A]">Hoyo {holeNum}</span>
                    <div>
                      <span className={`font-semibold ${oyesResult.first_place?.is_base ? 'text-[#1B4D3E]' : 'text-[#D4A373]'}`}>
                        {oyesResult.first_place?.player_name?.split(' ')[0]}
                      </span>
                      <span className="text-[#64748B] mx-1">/</span>
                      <span className={`font-semibold ${oyesResult.second_place?.is_base ? 'text-[#1B4D3E]' : 'text-[#D4A373]'}`}>
                        {oyesResult.second_place?.player_name?.split(' ')[0]}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </CardContent>
        </Card>
      )}
    </>
  );
}
